import type { JSX } from 'react';
import type { CSSProperties, ReactNode } from 'react';

export interface ChipProps {
  /** Выбран — оранжевая рамка и мягкая подложка. */
  active?: boolean;
  onClick?: () => void;
  icon?: ReactNode;
  /** Счётчик справа («Курсы 12»). */
  count?: number | null;
  title?: string;
  style?: CSSProperties;
  children: ReactNode;
}

/** Чип фильтра (порт `_ds/components/Chip`): радиус 8, активный — оранжевый. */
export function Chip({ active = false, onClick, icon, count, title, style, children }: ChipProps): JSX.Element {
  return (
    <button type="button" className="fk-ds-chip" aria-pressed={active} onClick={onClick} title={title} style={style}>
      {icon}
      {children}
      {count != null ? <span className="fk-ds-chip-count">{count}</span> : null}
    </button>
  );
}
